
import React, {Component} from 'react';
import Teams from '../components/Team/Team';
import Metrics from '../components/Metrics'

class AboutUs extends Component {
    render(){
        return(
            <div>
                <section className="developer_product_area">
                     <div class="img_text_container">
                        <img width="100%" src={require('../img/pink_container_ship.png')} alt="Snow" />
                        <div className='centered-bottom'>About Us</div>
                    </div>
                    <div className="container justify-content-center">
                        <div className="row mt_70 mb_40 justify-content-center" >
                            <div className="col-lg-8">
                                <h1 className="t_color3 wow fadeInUp header-text-2" data-wow-delay="0.2s">Mission</h1>
                                <hr></hr>
                                <div class="hemdahl-text mid-size-text justify-content-center">We believe that everyone should have sustainable access to sufficient healthy food and medicine.</div>
                            </div>
                        </div>
                        <div class="row mb_40 justify-content-center">
                            <div className="col-lg-8">
                                <h4 className="t_color3 wow fadeInUp header-text-2" data-wow-delay="0.2s">Vision</h4>
                                <hr></hr>
                                <div class="hemdahl-text mid-size-text justify-content-center">We aim to be the leading data analytics platform to assess product quality and safety in the cold chain.</div>
                            </div>
                        </div>
                        <div class="row mb_20 justify-content-center">
                            <div className="col-lg-8">
                                <h4 className="t_color3 wow fadeInUp header-text-2" data-wow-delay="0.2s">About Hemdahl</h4>
                                <hr></hr>
                                <div class="hemdahl-text mid-size-text justify-content-center">Hemdahl provides a SaaS platform that analyses logged data for temperature-sensitive products to provide unique, actionable insights into product quality and safety.</div>
                            </div>
                        </div>
                        <Metrics/>
                        <div className="row mt_100 justify-content-center p-3">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-6 justify-content-center p-4" >
                                <h2 className="hemdahl-text-dark">Leadership</h2>
                            </div>
                        </div>
                        <div className="row mb_10 justify-content-center p-4">
                            <Teams/>
                        </div>
                        <div className="row mt_10 justify-content-center" >
                            <div className="col-lg-8 text-center border border-secondary p-4">
                                <h4 className="t_color3 wow fadeInUp hemdahl-text-dark hemdahl-text-md" data-wow-delay="0.2s">Ready to get started?</h4>
                                <a className="btn_get btn_hover new_btn mt-2" href="./contact">GET IN TOUCH</a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default AboutUs;
